import { useIntl } from "react-intl";

import { Card, CardContent } from "~/hec/components/ui/card";
import { Heading } from "~/hec/components/ui/heading";
import type { GoalBannerLevel } from "~/hooks/learning-center/transformers";

import GoalBannerBtn from "./goal-banner-btn";
import GoalBannerProgressBar from "./goal-banner-progress-bar";
import GoalLevelCopy from "./goal-level-copy";
import messages from "./messages";
import type { GoalBannerEnrollment } from "./types";

/**
 * Port of hec-composable `goal-banner/levelCard.jsx`. One level's card:
 * "Level N" heading + loyalty copy + progress bar + CTA.
 */
const LevelCard = ({
  level,
  index,
  enrollment,
}: {
  level: GoalBannerLevel;
  index: number;
  enrollment: GoalBannerEnrollment;
}) => {
  const intl = useIntl();
  return (
    <Card
      className="max-w-[30.75rem] flex-1 rounded-md bg-white/90 p-8"
      data-testid="goal-banner-level-card"
    >
      <CardContent className="flex h-full flex-col">
        <div className="py-4 text-left">
          <Heading
            tag="h2"
            variant="h6"
            className="mb-1"
            data-testid="goal-banner-level-heading"
          >
            {intl.formatMessage(messages.levelHeading, {
              levelNumber: index + 1,
            })}
          </Heading>
          <GoalLevelCopy level={level} enrollment={enrollment} />
          <GoalBannerProgressBar levelData={level} />
          <GoalBannerBtn levelData={level} />
        </div>
      </CardContent>
    </Card>
  );
};

export default LevelCard;
